@if (contentInclude$ | async; as contentInclude) {
<ish-content-design-view-wrapper [include]="contentInclude">
  @for (pagelet of contentInclude.pageletIDs; track pagelet) {
  <ish-content-pagelet [pageletId]="pagelet" />
  }
</ish-content-design-view-wrapper>
}
